import { useState } from "react";
import { useDispatch } from "react-redux";
import Typography from "../../../Utility/Typography";
import Button from "../../../Utility/Button/Button";
import CommonModal from "../../../Utility/CommonModel/CommonModal";
import { Alert } from "@mui/material";
import { removeTeamMemberFromTeam } from "../../../Redux/Thunks/teamsThunk";

const RemoveTeamMemberModal = ({ isOpen, onClose, member, teamId, onSuccess, onError }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleRemove = async () => {
    if (!teamId || !member?.id) {
      setErrorMsg("Missing team or member.");
      return;
    }
    setErrorMsg("");
    setLoading(true);
    try {
      await dispatch(removeTeamMemberFromTeam({ teamId, userId: member.id })).unwrap();
      if (onSuccess) onSuccess(member);
      onClose();
    } catch (err) {
      const msg = err?.message || err?.response?.data?.message || "Failed to remove member.";
      setErrorMsg(msg);
      if (onError) onError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setErrorMsg("");
      onClose();
    }
  };

  if (!isOpen || !member) return null;

  return (
    <CommonModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Remove Member"
      width="max-w-md"
      loading={loading}
    >
      {errorMsg && (
        <Alert className="mb-4" severity="error">
          {errorMsg}
        </Alert>
      )}
      <Typography variant="text2" className="text-text-primary mb-4 block">
        Are you sure you want to remove this member from the team? This action cannot be undone.
      </Typography>

      <div className="flex justify-end gap-2 mt-6">
        <Button type="button" variant="outline" size="md" disabled={loading} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          type="button"
          variant="danger"
          size="md"
          disabled={loading}
          onClick={handleRemove}
          className="btn-danger-new"
        >
          {loading ? "Removing..." : "Remove"}
        </Button>
      </div>
    </CommonModal>
  );
};

export default RemoveTeamMemberModal;
